import './broadcastChannelPolyfill';

let channel = null;

export const getBroadcastChannel = () => {
  if (!channel) {
    const botRefId = window.parent.document.getElementById('netomiChatWindow').getAttribute('botRefId')
    const channelName = `netomiWebWidget_${botRefId}`
    channel = new BroadcastChannel(channelName)
  }
  return channel
}

export const setupBroadcastChannel = (app) => {
  const broadcastChannel = getBroadcastChannel()
  app.config.globalProperties.broadcastChannel = broadcastChannel
  
  // Also set up the global reference for backward compatibility
  const { setBroadcastChannel } = require('../globals')
  setBroadcastChannel(broadcastChannel)
}
